export default "__VITE_ASSET__yIxKlykP__"